<template>
	<Popup
		v-model="selfDisplay"
		title="修改sim卡"
		confirmBtnText="修改"
		@confirmClick="handleUpdateClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;"></span>激活日期</span>
				<el-date-picker
					:value="useTime"
					:editable="false"
					disabled
					type="datetime"
					value-format="yyyy-MM-dd HH:mm:ss"
				>
				</el-date-picker>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">机器ID</span>
				<el-input :value="mid" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>ICCID</span>
				<el-input v-model="iccid" placeholder="ICCID"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="iccidTip"><i class="b_icon"></i>请输入ICCID</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>生产日期</span>
				<el-date-picker
					v-model="createDate"
					:editable="false"
					placeholder="生产日期"
					type="date"
					value-format="yyyy-MM-dd"
					@change="handleCreateDateChange"
				>
				</el-date-picker>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="createDateTip"><i class="b_icon"></i>请选择生产日期</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>到期日期</span>
				<el-date-picker
					v-model="overDate"
					:editable="false"
					placeholder="到期日期"
					type="date"
					value-format="yyyy-MM-dd"
					@change="handleOverDateChange"
				>
				</el-date-picker>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="overDateTip"><i class="b_icon"></i>请选择到期日期</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>费用/元</span>
				<el-input v-model="cost" placeholder="费用/元"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="costTip"><i class="b_icon"></i>请输入数字</template></div>
			
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>套餐信息</span>
				<el-input v-model="meal" placeholder="套餐信息"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="mealTip"><i class="b_icon"></i>请输入套餐信息</template></div>
			
			<div class="base_form_row">
				<span class="b_label">备注</span>
				<el-input v-model="remark" placeholder="备注" :maxlength="100"></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>是否有效</span>
				<div class="b_checkbox_group">
					<el-radio-group v-model="isValid">
						<el-radio :label="1">有效</el-radio>
						<el-radio :label="2">无效</el-radio>
					</el-radio-group>
				</div>
			</div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../../api/index.js';
	
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			obj: {
				type: Object,
				default() { return {}; }
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				loading: false,
				selfDisplay: false,
				
				useTime: '',
				mid: '',
				iccid: '',
				createDate: '',
				overDate: '',
				cost: '',
				meal: '',
				remark: '',
				isValid: 1,
				iccidTip: false,
				createDateTip: false,
				overDateTip: false,
				costTip: false,
				mealTip: false
			}
		},
		methods: {
			// 点击修改
			handleUpdateClick() {
				if (!this.iccid.trim()) {
					this.iccidTip = true;
					return false;
				} else {
					this.iccidTip = false;
				}
				if (!this.createDate) {
					this.createDateTip = true;
					return false;
				} else {
					this.createDateTip = false;
				}
				if (!this.overDate) {
					this.overDateTip = true;
					return false;
				} else {
					this.overDateTip = false;
				}
				if (!this.floatReg.test(this.cost)) {
					this.costTip = true;
					return false;
				} else {
					this.costTip = false;
				}
				if (!this.meal.trim()) {
					this.mealTip = true;
					return false;
				} else {
					this.mealTip = false;
				}
				this.update();
			},
			// 选择生产日期
			handleCreateDateChange() {
				this.compareDate();
			},
			// 选择到期日期
			handleOverDateChange() {
				this.compareDate();
			},
			// 修改
			update() {
				const that = this;
				that.loading = true;
				let requestData = {
					id: that.obj.id,
					iccid: that.iccid,
					productionDate: that.createDate,
					packagesInfo: that.meal,
					dieDate: that.overDate,
					feeInfo: that.cost,
					simFlag: that.isValid,
					remark: that.remark
				};
				Api.updateSim(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 比较开始时间和结束时间
			compareDate() {
				if (this.createDate && this.overDate) {
					var createDate = new Date(this.createDate).getTime(),
						overDate = new Date(this.overDate).getTime();
					if (overDate < createDate) {
						this.overDate = '';
						this.$message.warning('到期日期不能小于生产日期！');
					}
				}
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.loading = false;
					this.useTime = this.obj.useTime;
					this.mid = this.obj.mid;
					this.iccid = this.obj.iccid;
					this.createDate = this.obj.createDate;
					this.overDate = this.obj.overDate;
					this.cost = this.obj.cost;
					this.meal = this.obj.meal;
					this.remark = this.obj.remark;
					this.isValid = this.obj.isValid;
					this.iccidTip = false;
					this.createDateTip = false;
					this.overDateTip = false;
					this.costTip = false;
					this.mealTip = false;
				}
			}
		}
	}
</script>

<style>
</style>
